import type {
  AttributeSetsConfig,
  EnumsMap,
  ProductAdminSchema,
} from "../types/meta";

const cache: {
  enums?: EnumsMap;
  attributeSets?: AttributeSetsConfig;
  productSchema?: ProductAdminSchema;
  presets?: any;
} = {};

export async function fetchEnums(): Promise<EnumsMap> {
  if (cache.enums) return cache.enums;
  const res = await fetch("/data/meta/enums.json", { cache: "no-store" });
  const json = (await res.json()) as EnumsMap;
  cache.enums = json;
  return json;
}

export async function fetchAttributeSets(): Promise<AttributeSetsConfig> {
  if (cache.attributeSets) return cache.attributeSets;
  const res = await fetch("/data/meta/attribute-sets.json", {
    cache: "no-store",
  });
  const json = (await res.json()) as AttributeSetsConfig;
  cache.attributeSets = json;
  return json;
}

export async function fetchProductSchema(): Promise<ProductAdminSchema> {
  if (cache.productSchema) return cache.productSchema;
  const res = await fetch("/data/meta/schema.product.json", {
    cache: "no-store",
  });
  const json = (await res.json()) as ProductAdminSchema;
  cache.productSchema = json;
  return json;
}

export async function fetchProductPresets(): Promise<any> {
  if (cache.presets) return cache.presets;
  const res = await fetch("/data/meta/presets.products.json", {
    cache: "no-store",
  });
  const json = await res.json();
  cache.presets = json;
  return json;
}
